import styled from "styled-components";
import { BsInfoCircle } from "react-icons/bs";

const A = styled.a`
  text-decoration: none;
`;

const StyledLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  svg {
    font-size: 2.5rem;
    color: var(--color-grey-900);
  }
`;

function Logo() {
  return (
    <A href="/">
      <StyledLogo>
        <BsInfoCircle />
        <h1>Countries Info</h1>
      </StyledLogo>
    </A>
  );
}

export default Logo;
